import instance from "@/services/apiService";
import apiUrls from "@/services/apiUrls";
import store from "@/store";

const updateCustomerInfo = (customerInfo) => {
  return instance.patch(`${apiUrls.CUSTOMER}`, {
    branch: store.getters.selectedBranch.id,
    phoneMobile: customerInfo.phoneMobile,
    firstName: customerInfo.firstName,
    lastName: customerInfo.lastName,
    customerDetail: {
      email: customerInfo.email,
    },
  });
};

export { updateCustomerInfo };
